import classNames from "classnames";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Button from "../../components/atomic/Button";
import { ChevronLeft } from "@untitled-ui/icons-react";

type Props = {
  title: string;
  back?: boolean;
  close?: () => void;
  backAction?: () => void;
  fullWidth?: boolean;
  taskName?: string;
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
  module?: string;
};

export default function Title({
  close,
  title,
  backAction,
  back = false,
  fullWidth = false,
  taskName,
  activeTab,
  setActiveTab,
  module,
}: Props) {
  return (
    <div
      className={classNames(
        "flex items-center justify-between",
        fullWidth ? "w-full" : "",
      )}
    >
      <div className="flex items-center space-x-3">
        {back && (
          <Button
            outline
            onClick={backAction}
            className="border-none !p-0"
          >
            <ChevronLeft className="h-6 w-6 text-[#4C4C4D]" />
          </Button>
        )}

        <div className="text-xl font-medium text-[#343F59]">{title}</div>
      </div>

      {!back && (
        <div className="flex items-center space-x-4">
          {taskName !== "Add New Verification" &&
            module === "verifications_module" && (
              <div className="inline-flex p-1 bg-gray-100 border border-gray-200 rounded-md">
                {[
                  { label: "Details", value: "Details" },
                  { label: "Timeline", value: "Timeline" },
                ].map((tab) => {
                  const isActive = tab.label === activeTab;

                  return (
                    <button
                      type="button"
                      key={tab.label}
                      onClick={() => setActiveTab?.(tab.label)}
                      className={`px-4 py-1.5 text-sm font-medium rounded-sm transition-all
                      ${
                        isActive
                          ? "bg-white text-gray-800 shadow-sm"
                          : "text-gray-500 hover:text-gray-700"
                      }`}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            )}

          <Button
            pxFour={false}
            onClick={close}
            outline
            className="border-none"
          >
            <XMarkIcon className="h-6 w-6 text-[#4C4C4D]" />
          </Button>
        </div>
      )}
    </div>
  );
}
